import React from 'react';
import { VscArrowRight } from 'react-icons/vsc';
import styled from 'styled-components';
import { NewsLetter } from '../../Sections/sec';
import { useNavigate } from 'react-router-dom';
import TeamBox from './TeamBox';
const OurTeam = () => {
  const navigate = useNavigate();
  return (
    <>
      <TeamWrapper>
        <div className="head">
          <span>|| Our Team</span>
          <h1>Meet The Team</h1>
          <p>
            Lorem ipsum dolor sit, amet consectetur adipisicing elit. Sapiente,
            accusantium soluta culpa excepturi neque ad.
          </p>
        </div>
        <TeamBox />
        <div
          className="al-btn"
          onClick={() => {
            navigate('/about-us/#our-team');
          }}>
          <p>See All</p>
          <VscArrowRight className="r-i" />
        </div>
      </TeamWrapper>
      <NewsLetter />
    </>
  );
};

const TeamWrapper = styled.section`
  padding: 100px 20px;
  min-height: 100vh;

  .head {
    width: 60%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    span {
      font-weight: 700;
      color: var(--bg-color);
    }
    h1 {
      font-size: 2.3rem;
      padding: 15px 0;
    }
    p {
      color: var(--text-color);
      max-width: 480px;
      font-size: 1.04rem;
      font-weight: 600;
      line-height: 1.7;
      text-align: center;
    }
  }

  .al-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2rem;
    width: 20%;
    background: #fff;
    border-radius: 50px;
    box-shadow: 0 0.3rem 1rem var(--bga-color);
    cursor: pointer;
    padding: 15px;
    margin: 3% auto;
    transition: all 600ms ease-in-out;

    p,
    .r-i {
      color: var(--bg-color);
      font-weight: 700;
    }

    &:active {
      transform: scale(0.9);
    }
  }

  @media screen and (max-width: 884px) {
    .head{
      width: 100%;
      h1{
        font-size: 2.4rem;
      }
    }
    .al-btn{
      width: 50%;
    }
  }

  @media screen and (max-width: 430px) {
    .head{
      width: 100%;
      h1{
        font-size: 2rem;
      }
    }
    .al-btn{
      width: 80%;
    }
  }
`;
export default OurTeam;
